import moment from "moment";
const state = {
    projectId: '',
    type: '1', 
    left_active:'', //点位组  图片组
    right_active:'', //点位  图片集
    time_slot: [
        (moment(new Date()).startOf('month').format("YYYY-MM-DD HH:mm:ss")),
        (moment(new Date()).endOf('month').format("YYYY-MM-DD HH:mm:ss"))
    ] //右侧时间区间
};

//操作管理
const mutations = {
    SET_PROJECTID(state, payload = null)
    {
        state.projectId = payload
    },
    set_TYPE(state, payload)
    {
        state.type = payload
    },
    SET_LEFT_ACTIVE(state, payload)
    {
        state.left_active = payload
    },
    SET_RIGHT_ACTIVE(state, payload)
    {
        state.right_active = payload
    },
    SET_TIME_SLOT(state,payload){
        state.time_slot = payload
    }
}

// 异步操作
const actions = {
    setCloudTaskPageQuery({ commit }, data = null)
    {
        commit('SET_PAGE_QUERY', data)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
